import React, { Component } from 'react';
import { connect } from 'react-redux';
import { changeProfileField } from 'redux/ducks/Post/Profile';
import ActionBar from 'scenes/V2/Shared/ActionBar';
import { isId, trackMixpanelPageView } from 'helpers/post';
import { getSetting } from 'helpers/enums';
import AdvancedOptionCard from 'scenes/V3/CreateAccountScene/OptionCards/AdvancedOptionCard';
import { Button } from 'reactstrap';

const SETTINGS_DESCRIPTIONS = {
  Sports: 'Coverage for a game, practice, tournament, camp, clinic, or similar.',
  Industrial: 'Coverage at a warehouse, distribution center, job site, or similar.',
  Medical: 'Coverage at a medical clinic, occupational health center, or similar.',
  'Performing Arts': 'Coverage at a theatre, festival, production set, or similar.',
  School: 'Coverage for a school setting.',
};

class EventSetting extends Component {
  constructor(props) {
    super(props);
    props.initialize('EventSetting');
    this.state = {
      selectedSettingId: isId(props.profile.eventSettingId) ? props.profile.eventSettingId : null,
    };
  }

  componentDidMount() {
    if (!this.props.editMode) {
      document.body.classList.add('hide-chat');
    }
    if (!this.props.editMode) trackMixpanelPageView('create-event/setting', this.props.user);
  }

  componentWillUnmount() {
    document.body.classList.remove('hide-chat');
  }

  onSelect = setting => () => {
    this.setState({ selectedSettingId: setting.id });
  };

  onContinue = () => {
    const { selectedSettingId } = this.state;
    if (!isId(selectedSettingId)) return;

    const { eventSettingId, settingDetailId, sportId } = this.props.profile;
    this.props.onChangeProfile('eventSettingId', selectedSettingId);

    if (selectedSettingId !== eventSettingId) {
      if (isId(settingDetailId)) this.props.onChangeProfile('settingDetailId', '');
      if (isId(sportId)) this.props.onChangeProfile('sportId', '');
    }

    this.props.history.push(`${this.props.baseUrl}/setting-detail`);
  };

  renderOptions() {
    const { eventSettings } = this.props;
    const { selectedSettingId } = this.state;

    return eventSettings.map(setting => (
      <AdvancedOptionCard
        key={setting.id}
        className="setting-option"
        title={setting.name}
        body={SETTINGS_DESCRIPTIONS[setting.name]}
        onClick={this.onSelect(setting)}
        selected={setting.id === selectedSettingId}
      />
    ));
  }

  renderCreateFlow() {
    const buttonDisabled = !isId(this.state.selectedSettingId);

    return (
      <div className="event-setting">
        <main>
          <header>
            <div className="screen-title gotham-bold-font">What's the job setting?</div>
          </header>
          <div className="content">
            <div className="setting-options">{this.renderOptions()}</div>
          </div>
        </main>
        <div className="navigation-buttons">
          <Button onClick={this.onContinue} className="continue-button" disabled={buttonDisabled}>
            <div>Continue &#8594;</div>
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const { authenticated, baseUrl, editMode } = this.props;

    if (editMode) {
      return (
        <div className="event-setting event-setting--edit">
          <header>
            <div className="screen-title">What's the job setting?</div>
          </header>
          <main>
            <div className="setting-options">{this.renderOptions()}</div>
          </main>
          <ActionBar
            editMode={editMode}
            currentStep="setting"
            backTo={`${baseUrl}/type`}
            onSaveAndContinue={this.onContinue}
            nextDisabled={() => !isId(this.state.selectedSettingId)}
            backDisabled={authenticated}
          />
        </div>
      );
    }

    return this.renderCreateFlow();
  }
}

const mapStateToProps = (state, ownProps) => ({
  eventSettings: getSetting({ hasSchool: state.post.profile.eventSettingId === 3 }),
  profile: state.post.profile,
  authenticated: state.session.authenticated,
  user: state.session.currentUser,
});

const mapDispatchToProps = dispatch => ({
  onChangeProfile: (name, value) => dispatch(changeProfileField({ name, value })),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventSetting);
